import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { AppliedFilter } from '@shared/components/filters/Domain/filter.model';
import { PRIMENGModule } from '@shared/prime-ng/prime-ng.module';
import { NgIf } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { TimezoneService } from '@shared/services/timezone.service';
import { TransformDateTimezonePipe } from '@shared/pipes/transformDateTimezone.pipe';

@Component({
  selector: 'app-date-range-filter',
  standalone: true,
  templateUrl: './date-range-filter.component.html',
  styleUrl: './date-range-filter.component.scss',
  imports: [PRIMENGModule, NgIf, ReactiveFormsModule, TranslateModule],
})
export class DateRangeFilterComponent implements OnInit {
  @Input() filter!: AppliedFilter;
  @Output() filterChange = new EventEmitter<AppliedFilter>();

  dateRangeForm!: FormGroup;

  constructor(
    private fb: FormBuilder,
    private timezoneServicePipe: TransformDateTimezonePipe,
    private timezoneService: TimezoneService,
  ) {}

  ngOnInit() {
    const start = this.filter?.value?.start ? new Date(this.filter.value.start) : undefined;
    const end = this.filter?.value?.finish ? new Date(this.filter.value.finish) : undefined;

    const validRange = start instanceof Date && end instanceof Date ? [start, end] : null;

    this.dateRangeForm = this.fb.group({
      range: [validRange, Validators.required],
    });

    // Clean up invalid partial values
    this.dateRangeForm.get('range')?.valueChanges.subscribe((range: Date[]) => {
      if (!Array.isArray(range)) return;
      const [from, to] = range;
      if (from && !to) {
        return;
      }

      if (!from && !to) {
        this.dateRangeForm.get('range')?.setValue(null, { emitEvent: false });
      }

      if (from === null || to === null) {
        this.dateRangeForm.get('range')?.setValue(null, { emitEvent: false });
      }

      this.emitUpdatedFilter();
    });
  }

  emitUpdatedFilter() {
    const range: Date[] = this.dateRangeForm.get('range')?.value || [];
    const [start, end] = range;

    if (!(start instanceof Date) || !(end instanceof Date)) return;

    const isSameDay =
      start.getFullYear() === end.getFullYear() &&
      start.getMonth() === end.getMonth() &&
      start.getDate() === end.getDate();

    let appliedFilter = {} as AppliedFilter;

    const startInTZ = this.timezoneService.convertToStartOfDay(start);
    const endInTZ = this.timezoneService.convertToEndOfDay(end);
    if (isSameDay) {
      // Clone the original end date to avoid mutating the form value directly
      const endNew = new Date(end);
      endNew.setHours(endNew.getHours() + 24);
      appliedFilter = {
        ...this.filter,
        isApplied: true,
        value: {
          start: startInTZ.toISOString(),
          finish: endInTZ.toISOString(),
        },
      };
    } else {
      appliedFilter = {
        ...this.filter,
        isApplied: true,
        value: {
          start: startInTZ.toISOString(),
          finish: endInTZ.toISOString(),
        },
      };
    }
    this.filterChange.emit(appliedFilter);
  }
}
